import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class NewSearchApiCall extends APICallV4 {
    _method = 'private/search';
    _type: Method = 'post';
}
